/** Generated by scripts/stampBuildInfo.cjs — do not edit manually. */
export const APP_BUILD_VERSION = "0.1.97";
export const APP_BUILD_ISO_TIME = "2026-11-03T11:15:53.788Z";
export const APP_PLAY_VERSION_CODE = 11;
export const APP_PLAY_VERSION_NAME = "1.0.11";
